import styled, { css } from 'styled-components';
import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { spacing, themeMode, variant, palette } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Box } from '../../primitives/Box/Box.es.js';
import Button from '../Button/Button.es.js';

const PAGINATION_SIZE = {
  md: "36px",
  lg: "48px"
};
const sizeStyles = variant({
  prop: "size",
  variants: {
    md: {
      minWidth: PAGINATION_SIZE.md,
      height: PAGINATION_SIZE.md,
      paddingY: 0,
      paddingX: "sm",
      fontSize: "md",
      lineHeight: PAGINATION_SIZE.md
    },
    lg: {
      minWidth: PAGINATION_SIZE.lg,
      height: PAGINATION_SIZE.lg,
      paddingY: 0,
      paddingX: "md",
      fontSize: "lg",
      lineHeight: PAGINATION_SIZE.lg
    }
  }
});
const shapeStyles = variant({
  prop: "shape",
  variants: {
    default: {},
    round: {
      borderRadius: "round"
    }
  }
});
const PaginationPageButton = styled(Button)`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: transparent;
    border: none;
    outline: none;
    padding: 0;
    margin: 0 ${spacing("xxs")};
    border-radius: 2px;
    cursor: pointer;

    ${sizeStyles};
    ${shapeStyles};

    color: ${themeMode({ light: palette("neutral.900"), dark: palette("neutral.0") })};

    ${({ onClick }) => onClick ? css`
                  &:hover {
                      background-color: ${themeMode({ light: palette("neutral.100"), dark: palette("neutral.800") })};
                  }
                  &:active {
                      background-color: ${themeMode({ light: palette("neutral.200"), dark: palette("neutral.700") })};
                  }

                  &[aria-pressed='true'] {
                      background-color: ${themeMode({
  light: palette("neutral.200"),
  dark: palette("neutral.800")
})};
                  }
              ` : css`
                  pointer-events: none;
              `}
`;
const ArrowButton = styled(PaginationPageButton)`
    padding: 0;
    cursor: pointer;
`;
const PaginationComponent = styled(Box)`
    display: flex;
    align-items: center;
    justify-content: start;
`;

export { ArrowButton, PaginationComponent, PaginationPageButton };
//# sourceMappingURL=styled.es.js.map
